import { useGraphQLQuery } from '@betterment/graphql';

import { FourOhOneKContributionsQueryResult } from './data';
import {
  FourOhOneKContributionsDocument,
  FourOhOneKContributionsQuery,
  FourOhOneKContributionsQueryVariables,
} from './graphql/query.fourOhOneKContributions.generated';

export const useFourOhOneKContributionsQuery = (
  householdId: string,
  accountId: string
): FourOhOneKContributionsQueryResult => {
  const { data, loading: isLoading } = useGraphQLQuery<
    FourOhOneKContributionsQuery,
    FourOhOneKContributionsQueryVariables
  >(FourOhOneKContributionsDocument, {
    variables: {
      householdId,
      accountId,
    },
    throwOnError: true,
  });

  const householdMembers = data?.household?.__typename === 'Household' ? data.household.members : undefined;
  const filteredContributionData = householdMembers?.find(member =>
    data?.envelopeAccount?.accountHolders?.some(holder => holder.id === member.id)
  );

  return {
    isLoading,
    employeeContributions: filteredContributionData?.fourOhOneKContributions,
    employers: filteredContributionData?.employers,
    clientId: filteredContributionData?.id,
  };
};
